module.exports = __webpack_public_path__ + "static/top-871559ef368fac6c9ad5b9ee2ceea9d9.png";